<template>
  <v-expansion-panels
    :value="matchOpenedItem"
    class="elevation-0 nav-panels-fullwidth"
    accordion
    multiple
    dense
    flat
  >
    <template v-for="(nav, idx) in navs">
      <v-expansion-panel
        v-if="!nav.dontExist"
        :key="`${nav.name} - ${idx}`"
        :readonly="!nav.expandable"
        :class="{ variant }"
        class="panel elevation-0"
      >
        <v-expansion-panel-header
          v-show="!nav.hidden"
          v-slot="{ open: isPanelOpen }"
          class="panel_header elevation-0 pa-0"
          hide-actions
        >
          <div
            v-if="isPanelOpen"
            class="pos-a Primary100 b-rad-full nav-expanded-bg"
          />
          <v-list-item
            :to="nav.children && !nav.showPath ? '' : nav.path"
            :disabled="nav.disabled"
            :class="!nav.path && 'cursor-normal'"
            active-class="shaped_active"
            dense
            nav
          >
            <v-list-item-icon v-if="nav.icon">
              <v-icon>{{ nav.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content class="nav-item-content">
              <v-list-item-title class="nav-item-title d-flex align-center">
                <span class="nav-item-text">{{ nav.text ? $t(nav.text) : '' }}</span>
                <v-icon
                  v-if="nav.expandable"
                  :class="{ rotate180: isPanelOpen }"
                  class="nav-item-icon flex-shrink-0 ml-1"
                >
                  mdi-chevron-down
                </v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-expansion-panel-header>

        <v-expansion-panel-content
          v-if="nav.children"
          class="panel_content elevation-0 pa-0"
          :class="{ transparent: !nav.expandable }"
        >
          <nav-items
            :navs="nav.children"
            :variant="variant"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavItems',

  props: {
    navs: {
      type: Array,
      default: () => []
    },

    variant: {
      type: Boolean,
      default: false
    },

    root: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      open: false,
      matchOpenedItem: []
    };
  },

  computed: {
    ...mapGetters({ getIncludedRoute: 'app/getIncludedRoute' }),
    includedRoute: {
      immediate: true,
      get() {
        return this.getIncludedRoute(this.$route.name).map(({ path }) => path);
      }
    }
  },

  watch: {
    includedRoute() {
      this.calcOpenItem();
    }
  },

  mounted() {
    this.calcOpenItem();
  },

  methods: {
    calcOpenItem() {
      setTimeout(() => {
        const displayArray = [];
        if (this.root) {
          this.navs.forEach((el, i) => {
            displayArray.push(i);
          });

          this.matchOpenedItem = displayArray;
          return;
        }

        this.navs.filter(({ path }, i) => {
          if (
            path === '/' ||
            path === '/mr' ||
            this.includedRoute.includes(path)
          ) {
            displayArray.push(i);
            return true;
          }
        });

        this.matchOpenedItem = displayArray;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-panels-fullwidth {
  width: 100%;
}

/* 展開項目的 Primary100 底色：向左右延伸，確保長文字如 Merchant Management 完全被包覆 */
.nav-expanded-bg {
  top: 0;
  bottom: 0;
  left: -6px;
  right: -10px;
}

.panel {
  width: 100%;
  background-color: #ffffff00 !important;

  ::v-deep {
    .v-expansion-panel-content__wrap {
      padding: 0 !important;
      padding-left: 16px !important;
    }
  }
  &.variant {
    ::v-deep {
      .v-expansion-panel-content__wrap {
        padding: 0 !important;
      }
    }
  }
}

.panel_header {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 38px !important;
  width: 100%;
  overflow: visible;

  ::v-deep {
    .v-list-item .v-list-item__content {
      color: black;
    }
    .v-list-item--link:before {
      border-radius: 999px;
      /* 確保 :before 底色延伸至父元素全寬 */
      left: 0 !important;
      right: 0 !important;
    }

    .v-expansion-panel-header__icon {
      position: absolute;
      height: 100%;
      margin: 0;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .rotate180 {
      transform: rotate(180deg);
    }
  }
}

::v-deep {
  .v-expansion-panel-header--active ~ .panel_content {
    background-color: $Surface500;
    border-radius: 999px;
  }
}

.nav_divider {
  position: absolute;
  width: 95%;
  bottom: 0;
  right: 0;
}

.nav-item-content {
  min-width: 0; /* 允許 flex 子元素縮小，避免英文長文字跑版 */
}

.nav-item-title {
  min-width: 0;
  width: 100%;
}

.nav-item-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-list-item {
  height: 100% !important;
  min-height: 34px !important;
  .v-list-item__icon * {
    color: $Primary600 !important;
  }
}

/* active-class="shaped_active" 時套用的樣式，需與 v-list-item--active 一致 */
.v-list-item--active,
.shaped_active {
  background-color: $Primary600 !important;
  border-radius: 999px;
  .v-list-item__content {
    color: $Surface !important;
  }
  .v-list-item__icon * {
    color: $Surface !important;
  }
}
</style>
